import 'draggabilly/dist/draggabilly.pkgd.min.js'

export default {
  init() {
    var queryWidth = 64 * parseFloat($('html').css('font-size'));
    if ($(window).width() > queryWidth) $('.about_service').draggabilly();
   
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-studio-portfolio.js